import { WEBSITE_DESC, WEBSITE_LINK_TO_MAIN_PAGE, WEBSITE_NAME, WEBSITE_TAGS, WEBSITE_TITLE, WEBSITE_URL_LOGO } from '../utils/constants';
import Document, { Html, Head, Main, NextScript, DocumentContext } from 'next/document';

export const metadata = {
    title: WEBSITE_TITLE,
    description: WEBSITE_DESC,
    applicationName: WEBSITE_NAME,
    icons: [
        { rel: 'icon', url: '/favicon.ico' },
        { rel: 'apple-touch-icon', url: '/apple-touch-icon.png' },
        { rel: 'icon', url: '/favicon-32x32.png', sizes: '32x32', type: 'image/png' },
        { rel: 'icon', url: '/favicon-16x16.png', sizes: '16x16', type: 'image/png' },
    ],
    manifest: '/site.webmanifest',
    keywords: WEBSITE_TAGS,
    themeColor: '#ffffff',
    openGraph: {
        type: 'website',
        url: WEBSITE_LINK_TO_MAIN_PAGE,
        title: WEBSITE_NAME,
        description: WEBSITE_DESC,
        images: [{ url: WEBSITE_URL_LOGO }],
    },
    other: { ['msapplication-TileColor']: '#da532c' },
    metadataBase: new URL(WEBSITE_LINK_TO_MAIN_PAGE),
};

export default class MyDocument extends Document<{ nonce?: string }> {
    static async getInitialProps(ctx: DocumentContext) {
        const initialProps = await Document.getInitialProps(ctx);
        const nonce = ctx.req?.headers['x-csp-nonce'] as string | undefined;
        return { ...initialProps, nonce };
    }

    render() {
        const { nonce } = this.props;

        return (
            <Html lang="en">
                <Head>
                    <meta name="description" content={metadata.description} />
                    <meta name="application-name" content={metadata.applicationName} />
                    {metadata.icons.map((icon, index) => (
                        <link key={index} rel={icon.rel} href={icon.url} sizes={icon.sizes} type={icon.type} />
                    ))}
                    <link rel="manifest" href={metadata.manifest} />
                    <meta name="keywords" content={metadata.keywords} />
                    <meta name="theme-color" content={metadata.themeColor} />
                    <meta property="og:type" content={metadata.openGraph.type} />
                    <meta property="og:url" content={metadata.openGraph.url} />
                    <meta property="og:title" content={metadata.openGraph.title} />
                    <meta property="og:description" content={metadata.openGraph.description} />
                    <meta property="og:image" content={metadata.openGraph.images[0].url} />
                    <meta name="msapplication-TileColor" content={metadata.other['msapplication-TileColor']} />
                </Head>
                <body>
                    <Main />
                    <NextScript nonce={nonce} />
                    <script
                        nonce={nonce}
                        dangerouslySetInnerHTML={{
                            __html: `window.__NONCE__ = "${nonce || ''}";`,
                        }}
                    />
                </body>
            </Html>
        );
    }
}
